import { DashboardTicketDTO } from '../models/DashboardTicket'
import { TicketRepository } from '../repositories/TicketRepository'

export function ListTicketCase(ticketRepository: TicketRepository) {
  return async function (data?: DashboardTicketDTO) {
    return await ticketRepository.listTicket(data)
  }
}
